import { defineComponent as _defineComponent } from 'vue';
import { IonPage } from "@ionic/vue";
import TheLoader from "@/components/TheLoader.vue";
import { onMounted } from "vue";
import { Auth } from "@/services/AuthService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OpenIdSignIn',
    setup(__props, { expose: __expose }) {
        __expose();
        onMounted(() => {
            Auth.Instance.signIn();
        });
        const __returned__ = { get IonPage() { return IonPage; }, TheLoader };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
